<template>
  <div class="pb-2">
    <h5>{{ this.post_seleccionado.category_path }}</h5>
    <h6 class="h4 pt-1">
      <div class="alert alert-success font-weight-bold d-flex justify-content-between" role="alert">
        <div class="w-100">
          <i class="fas fa-equals pr-2"></i>
          Publicaciones similares: {{ this.publicaciones }}
        </div>
        <a :href="this.dominio" target="_blank">
          <i class="fas fa-info-circle text-info fa-lg" data-toggle="tooltip" data-placement="top" title="Manual de usuario"></i>
        </a>
      </div>
    </h6>
    <form-wizard ref="'wizard'" next-button-text="Siguiente" title="" :start-index="0" subtitle="" color="#3490dc"
      back-button-text="Anterior" finish-button-text="Finalizar" step-size="xs" @on-complete="onComplete"
      @on-change="onChange">
      <tab-content title="Filtrar productos" icon="fas fa-filter">
        <div id="accordion">
          <div class="card card-primary">
            <div class="card-header" id="headingOne">
              <h5 class="mb-0">
                <div class="bg bg-light" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true"
                  aria-controls="collapseOne">
                  <i class="fas fa-filter pr-2 text-danger"></i>
                  Filtrar por
                </div>
              </h5>
            </div>

            <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordion">
              <div class="card-body">

                <!-- marca :category="this.path"></marca -->

                <div class="form-group row">
                  <label for="COMBO_state_id"
                    class="col-md-2 col-form-label text-md-right text-nowrap">Estado<sup>&nbsp;(*)&nbsp;</sup></label>
                  <div class="col-md-9">
                    <div class="row">
                      <div class="input-group col-11">
                        <select ref="state" v-model="selected_state" name="state_id" id="COMBO_state_id"
                          class="form-control" @change="getfilterPosts">
                          <option value="T">Todos</option>
                          <option v-for="(state, index) in states" v-bind:value="state.id" :key="index">
                            {{ state.title }}
                          </option>
                        </select>
                      </div>
                      <span id="span_COMBO_state_id" class="my-auto" aria-hidden="true"></span>
                    </div>
                    <div id="div_COMBO_state_id" class="form-text text-danger"></div>
                    <div class="form-text text-danger"></div>
                  </div>
                </div>

                <ancho v-if="this.post_seleccionado.ancho_id != null"></ancho>

                <altura v-if="this.post_seleccionado.altura_id != null"></altura>

                <cantidadNeumaticos v-if="this.post_seleccionado.cantidadneumatico_id != null"></cantidadNeumaticos>

                <color v-if="this.post_seleccionado.color != ''"></color>

                <cortaCorriente v-if="this.post_seleccionado.cortacorriente_id != null"></cortaCorriente>

                <diametro v-if="this.post_seleccionado.diametro_id != null"></diametro>

                <edad v-if="this.post_seleccionado.edad_id != null"></edad>

                <estilo v-if="this.post_seleccionado.estilo_id != null"></estilo>

                <indiceCarga v-if="this.post_seleccionado.indicecarga_id != null"></indiceCarga>

                <indiceVelocidad v-if="this.post_seleccionado.indicevelocidad_id != null"></indiceVelocidad>

                <lado v-if="this.post_seleccionado.lado_id != null"></lado>

                <largo v-if="this.post_seleccionado.largo_id != null"></largo>

                <material v-if="this.post_seleccionado.material_id != null" @getMaterial="getMaterial"
                  :valmaterial="this.post_seleccionado.material_id"></material> 

                <materialExterior v-if="this.post_seleccionado.materialesexterior_id != null"></materialExterior>

                <materialInterior v-if="this.post_seleccionado.materialesinterior_id != null"></materialInterior>

                <posicion v-if="this.post_seleccionado.posicion_id != null"></posicion>

                <sensorPresencia v-if="this.post_seleccionado.sensorpresencia_id != null"></sensorPresencia>

                <sirena v-if="this.post_seleccionado.sirena_id != null"></sirena>

                <tamano v-if="this.post_seleccionado.tamano_id != null"></tamano>

                <tamanoPantalla v-if="this.post_seleccionado.tamanopantalla_id != null"></tamanoPantalla>

                <tipoCasco v-if="this.post_seleccionado.tipocasco_id != null"></tipoCasco>

                <tipoMontaje v-if="this.post_seleccionado.tipomontaje_id != null"></tipoMontaje>

                <transductor v-show="this.post_seleccionado.transductor_id != null" @getTransductor="getTransductor"
                  :valtransductor="this.post_seleccionado.transductor_id"></transductor>

                <unidadPorEnvase v-if="this.post_seleccionado.unidadporenvase_id != null"></unidadPorEnvase>

                <voltaje v-if="this.post_seleccionado.voltaje_id != null"></voltaje>

                <volumen v-if="this.post_seleccionado.volumen_id != null"></volumen>

                <artista v-if="this.post_seleccionado.artista_id != null" @getArtista="getArtista"
                  :valartista="this.post_seleccionado.artista_id"></artista>  

                <formato v-if="this.post_seleccionado.formato_id != null" @getFormato="getFormato"
                  :valformato="this.post_seleccionado.formato_id"></formato>  
                  
                <idioma v-if="this.post_seleccionado.idioma_id != null" @getIdioma="getIdioma"
                  :validioma="this.post_seleccionado.idioma_id"></idioma>

                <AroBicicleta v-if="this.post_seleccionado.arobicicleta_id != null" @getAro="getAro"
                  :valaro="this.post_seleccionado.arobicicleta_id"></AroBicicleta>

                <Genero v-if="this.post_seleccionado.genero_id != null" @getGenero="getGenero"
                  :valgenero="this.post_seleccionado.genero_id"></Genero>  

                <Sexo v-if="this.post_seleccionado.sexo_id != null" @getSexo="getSexo"
                  :valsexo="this.post_seleccionado.sexo_id"></Sexo>

                <materialjoya v-if="this.post_seleccionado.materialjoya_id != null" @getMaterialjoya="getMaterialjoya"
                  :valmaterialjoya="this.post_seleccionado.materialjoya_id"></materialjoya>  

                <raza v-if="this.post_seleccionado.raza_id != null" @getRaza="getRaza"
                  :valraza="this.post_seleccionado.raza_id"></raza>  

                <titulo v-if="this.post_seleccionado.titulo_id != null" @getTitulo="getTitulo"
                  :valtitulo="this.post_seleccionado.titulo_id"></titulo>    

                <evento v-if="this.post_seleccionado.evento_id != null" @getEvento="getEvento"
                  :valevento="this.post_seleccionado.evento_id"></evento>     

                <localidad v-if="this.post_seleccionado.localidad_id != null" @getLocalidad="getLocalidad"
                  :vallocalidad="this.post_seleccionado.localidad_id"></localidad>    

                <tallaBebe v-if="this.post_seleccionado.tallabebe_id != null" @getTallaBebe="getTallaBebe"
                  :valtallabebe="this.post_seleccionado.tallabebe_id"></tallaBebe>  

                <tallaCalzado v-if="this.post_seleccionado.tallacalzado_id != null" @getTallaCalzado="getTallaCalzado"
                  :valtallacalzado="this.post_seleccionado.tallacalzado_id"></tallaCalzado>
                  
                <tallaRopa v-if="this.post_seleccionado.tallaropa_id != null" @getTallaRopa="getTallaRopa"
                  :valtallaropa="this.post_seleccionado.tallaropa_id"></tallaRopa>  

              </div>
            </div>
          </div>
        </div>
        <!-- post-list-default
      :key="currentPage"
      @getCurrentPage="getCurrentPage"
      v-if="total > 0"
      :posts="posts"
      :pCurrentPage="currentPage"
      :total="total"
    ></post-list-default -->
      </tab-content>
      <tab-content title="Información adicional" icon="fas fa-clipboard-list">
        <div class="form-group row">
          <label for="OCOMB_pujastock" class="col-md-2 col-form-label text-md-right">Cantidad ({{
            this.post_seleccionado.stock }} disponibles)<sup>&nbsp;(*)&nbsp;</sup></label>
          <div class="col-md-9">
            <div class="row">
              <div class="input-group col-11">
                <select ref="cantidad" v-model="selected_cantidad" name="puja_stock" id="OCOMB_pujastock"
                  class="form-control" @change="getfilterPosts">
                  <option value="">
                    Selecciona cantidad de productos<sup>&nbsp;(*)&nbsp;</sup>
                  </option>
                  <option v-for="number in this.post_seleccionado.stock" v-bind:value="number" :key="number">
                    {{ number }}
                  </option>
                </select>
              </div>
              <span id="span_OCOMB_pujastock" class="my-auto" aria-hidden="true"></span>
            </div>
            <div id="div_OCOMB_pujastock" class="form-text text-danger"></div>
          </div>
        </div>
        <div class="form-group row">
          <label for="OCOMB_pujatime" class="col-md-2 col-form-label text-md-right">Tiempo de
            oferta<sup>&nbsp;(*)&nbsp;</sup></label>
          <div class="col-md-9">
            <div class="row">
              <div class="input-group col-11">
                <select ref="pais" v-model="selected_pujatime" name="puja_time" id="OCOMB_pujatime" class="form-control"
                  @change="validar">
                  <option v-show="this.publicaciones > 1" value="">
                    Selecciona tiempo de la oferta<sup>&nbsp;(*)&nbsp;</sup>
                  </option>
                  <option value="1">Compra directa</option>
                  <!-- <option v-show="this.publicaciones > 0" value="5">5 minutos</option> -->
                  <!-- <option v-show="this.publicaciones > 0" value="180">3 horas</option> -->
                  <!-- <option v-show="this.publicaciones > 0" value="360">6 horas</option> -->
                  <option v-if="this.publicaciones > 0" value="720">12 horas</option>
                  <option v-if="this.publicaciones > 0" value="1440">24 horas</option>
                  <option v-if="this.publicaciones > 0" value="2880">48 horas</option>
                </select>
              </div>
              <span id="span_OCOMB_pujatime" class="my-auto" aria-hidden="true"></span>
            </div>
            <div id="div_OCOMB_pujatime" class="form-text text-danger"></div>
          </div>
        </div>
        <div class="form-group row">
          <label for="OCOMB_direccion"
            class="col-md-2 col-form-label text-md-right">Dirección<sup>&nbsp;(*)&nbsp;</sup></label>
          <div class="col-md-9">
            <div class="row">
              <div class="input-group col-11">
                <select ref="pais" v-model="selected_address" name="direccion" id="OCOMB_direccion" class="form-control"
                  @change="getfilterPosts">
                  <option value="">
                    Selecciona una dirección<sup>&nbsp;(*)&nbsp;</sup>
                  </option>
                  <option v-for="(address, index) in addresses" v-bind:value="address.id" :key="index">
                    {{ '[' + address.name + '] ' + address.street_address + ' ' + address.number_address + ', ' +
                      address.city_address
                    }}
                  </option>
                </select>
              </div>
              <span id="span_OCOMB_direccion" class="my-auto" aria-hidden="true"></span>
            </div>
            <div id="div_OCOMB_direccion" class="form-text text-danger"></div>
          </div>
        </div>
        <div class="form-group row">
        <div :class="elementoClaseNotificacion">
          <i></i>
          <input type="checkbox" name="notification" id="notification" v-model="isChecked" @change="setNotificar" />
          Acepto los <a :href="url_terminos" target="_blank"  rel="noopener">Términos y Condiciones</a>
        </div>
      </div>
      </tab-content>
    </form-wizard>
  </div>
</template>
<script>
import TransductorComponentVue from './TransductorComponent.vue';
export default {
  components: {
    TransductorComponentVue
  },
  props: {
    post_seleccionado: '',
    transductor: {
      type: Number
    }
  },
  mounted() { 
    this.getPosts();
    this.loadStates();
    this.loadAddress();
    $('[data-toggle="tooltip"]').tooltip();
  },
  updated() {
    this.validar();
  },
  methods: {
    postClick: function (p) {
      this.postSelected = p;
    },
    loadStates() {
      axios.get("/Dashbord/states").then((response) => {
        this.states = response.data;
      });
    },
    loadAddress() {
      axios.get("/api/user/address").then((response) => {
        this.addresses = response.data.data;
      });
    },
    getPosts() {
      //console.log("/api/post/" + this.post_seleccionado.category_path + "/" + this.post_seleccionado.modelo + "/" + this.post_seleccionado.marca + "/" + this.post_seleccionado.id + "/categoriaPath");
      fetch(
        "/api/post/" + this.post_seleccionado.category_path + "/" + this.post_seleccionado.modelo + "/" + this.post_seleccionado.marca + "/" + this.post_seleccionado.id + "/categoriaPath")
        .then((response) => response.json())
        .then((json) => {
          this.posts = json.data.data;
          this.total = json.data.last_page;
          this.$nextTick(function () { $('.selectpicker').selectpicker('refresh'); });

          if (this.selected_address != '') {
            let direccion_seleccionada = this.addresses.filter((item) => (item['id'] == this.selected_address));
            this.selected_region_comprador = direccion_seleccionada[0]['region_id'];
          }

          let filters = {
            transductor_id: this.selected_transductor,
            arobicicleta_id: this.selected_aro,
            tallabebe_id: this.selected_tallabebe,
            tallacalzado_id: this.selected_tallacalzado,
            tallaropa_id: this.selected_tallaropa,
            genero_id: this.selected_genero,
            sexo_id: this.selected_sexo,
            materialjoya_id: this.selected_materialjoya,
            material_id: this.selected_material,
            raza_id: this.selected_raza,
            titulo_id: this.selected_titulo,
            localidad_id: this.selected_localidad,
            evento_id: this.selected_evento,
            artista_id: this.selected_artista,
            formato_id: this.selected_formato,
            idioma_id: this.selected_idioma,
            state_id: this.selected_state,
            stock: this.selected_cantidad,
            delivery_regions_id: this.selected_region_comprador
          };

          if (this.selected_state == 'T' || this.selected_state == null) {
            delete filters['state_id'];
          }
          if (this.selected_transductor == 'T' || this.selected_transductor == null) {
            delete filters['transductor_id'];
          }
          if (this.selected_aro == 'T' || this.selected_aro == null) {
            delete filters['arobicicleta_id'];
          }      
          if (this.selected_tallabebe == 'T' || this.selected_tallabebe == null) {
            delete filters['tallabebe_id'];
          }
          if (this.selected_tallacalzado == 'T' || this.selected_tallacalzado == null) {
            delete filters['tallacalzado_id'];
          }
          if (this.selected_tallaropa == 'T' || this.selected_tallaropa == null) {
            delete filters['tallaropa_id'];
          }
          if (this.selected_genero == 'T' || this.selected_genero == null) {
            delete filters['genero_id'];
          }
          if (this.selected_sexo == 'T' || this.selected_sexo == null) {
            delete filters['sexo_id'];
          }
          if (this.selected_materialjoya == 'T' || this.selected_materialjoya == null) {
            delete filters['materialjoya_id'];
          }
          if (this.selected_material == 'T' || this.selected_material == null) {
            delete filters['material_id'];
          }
          if (this.selected_raza == 'T' || this.selected_raza == null) {
            delete filters['raza_id'];
          }
          if (this.selected_titulo == 'T' || this.selected_titulo == null) {
            delete filters['titulo_id'];
          }
          if (this.selected_evento == 'T' || this.selected_evento == null) {
            delete filters['evento_id'];
          }
          if (this.selected_artista == 'T' || this.selected_artista == null) {
            delete filters['artista_id'];
          }
          if (this.selected_formato == 'T' || this.selected_formato == null) {
            delete filters['formato_id'];
          }
          if (this.selected_idioma == 'T' || this.selected_idioma == null) {
            delete filters['idioma_id'];
          }
          if (this.selected_localidad == 'T' || this.selected_localidad == null) {
            delete filters['localidad_id'];
          }
          if (this.selected_cantidad < 1) {
            delete filters['stock'];
          }
          if (this.selected_address == '') {
            delete filters['delivery_regions_id'];
          }

          var mJson = this.posts;
          let arrayFilter = this.multiFilter(mJson, filters);
          this.publicaciones = arrayFilter.length;
          this.array_json = arrayFilter;
          this.array_json_original = mJson;
        });
    },
    getCurrentPage: function (val) {
      this.currentPage = val;
      this.getPosts();
    },
    getTransductor(transductor) {
      this.selected_transductor = transductor;
      if (this.selected_address != '') {
        let direccion_seleccionada = this.addresses.filter((item) => (item['id'] == this.selected_address));
        this.selected_region_comprador = direccion_seleccionada[0]['region_id'];
      }

      let filters = {
        transductor_id: this.selected_transductor,
        state_id: this.selected_state,
        stock: this.selected_cantidad,
        delivery_regions_id: this.selected_region_comprador
      };

      if (this.selected_state == 'T' || this.selected_state == null) {
        delete filters['state_id'];
      }
      if (this.selected_transductor == 'T' || this.selected_transductor == null) {
        delete filters['transductor_id'];
      }
      if (this.selected_cantidad < 1) {
        delete filters['stock'];
      }
      if (this.selected_address == '') {
        delete filters['delivery_regions_id'];
      }

      var mJson = this.posts;
      let arrayFilter = this.multiFilter(mJson, filters);
      this.publicaciones = arrayFilter.length;
      this.array_json = arrayFilter;
    },
    getAro(aro) {
      this.selected_aro = aro;
      if (this.selected_address != '') {
        let direccion_seleccionada = this.addresses.filter((item) => (item['id'] == this.selected_address));
        this.selected_region_comprador = direccion_seleccionada[0]['region_id'];
      }

      let filters = {
        arobicicleta_id: this.selected_aro,
        state_id: this.selected_state,
        stock: this.selected_cantidad,
        delivery_regions_id: this.selected_region_comprador
      };

      if (this.selected_state == 'T' || this.selected_state == null) {
        delete filters['state_id'];
      }
      if (this.selected_aro == 'T' || this.selected_aro == null) {
        delete filters['arobicicleta_id'];
      }
      if (this.selected_cantidad < 1) {
        delete filters['stock'];
      }
      if (this.selected_address == '') {
        delete filters['delivery_regions_id'];
      }
      //console.log(this.posts);
      var mJson = this.posts;
      let arrayFilter = this.multiFilter(mJson, filters);
      this.publicaciones = arrayFilter.length;
      this.array_json = arrayFilter;
    },
    getGenero(genero) {
      this.selected_genero = genero;
      if (this.selected_address != '') {
        let direccion_seleccionada = this.addresses.filter((item) => (item['id'] == this.selected_address));
        this.selected_region_comprador = direccion_seleccionada[0]['region_id'];
      }

      let filters = {
        genero_id: this.selected_genero,
        state_id: this.selected_state,
        stock: this.selected_cantidad,
        delivery_regions_id: this.selected_region_comprador
      };

      if (this.selected_state == 'T' || this.selected_state == null) {
        delete filters['state_id'];
      }
      if (this.selected_genero == 'T' || this.selected_genero == null) {
        delete filters['genero_id'];
      }
      if (this.selected_cantidad < 1) {
        delete filters['stock'];
      }
      if (this.selected_address == '') {
        delete filters['delivery_regions_id'];
      }
      //console.log(this.posts);
      var mJson = this.posts;
      let arrayFilter = this.multiFilter(mJson, filters);
      this.publicaciones = arrayFilter.length;
      this.array_json = arrayFilter;
    },
    getSexo(sexo) {
      this.selected_sexo = sexo;
      if (this.selected_address != '') {
        let direccion_seleccionada = this.addresses.filter((item) => (item['id'] == this.selected_address));
        this.selected_region_comprador = direccion_seleccionada[0]['region_id'];
      }

      let filters = {
        sexo_id: this.selected_sexo,
        state_id: this.selected_state,
        stock: this.selected_cantidad,
        delivery_regions_id: this.selected_region_comprador
      };

      if (this.selected_state == 'T' || this.selected_state == null) {
        delete filters['state_id'];
      }
      if (this.selected_sexo == 'T' || this.selected_sexo == null) {
        delete filters['sexo_id'];
      }
      if (this.selected_cantidad < 1) {
        delete filters['stock'];
      }
      if (this.selected_address == '') {
        delete filters['delivery_regions_id'];
      }
      //console.log(this.posts);
      var mJson = this.posts;
      let arrayFilter = this.multiFilter(mJson, filters);
      this.publicaciones = arrayFilter.length;
      this.array_json = arrayFilter;
    },
    getMaterialjoya(materialjoya) {
      this.selected_materialjoya = materialjoya;
      if (this.selected_address != '') {
        let direccion_seleccionada = this.addresses.filter((item) => (item['id'] == this.selected_address));
        this.selected_region_comprador = direccion_seleccionada[0]['region_id'];
      }

      let filters = {
        materialjoya_id: this.selected_materialjoya,
        state_id: this.selected_state,
        stock: this.selected_cantidad,
        delivery_regions_id: this.selected_region_comprador
      };

      if (this.selected_state == 'T' || this.selected_state == null) {
        delete filters['state_id'];
      }
      if (this.selected_materialjoya == 'T' || this.selected_materialjoya == null) {
        delete filters['materialjoya_id'];
      }
      if (this.selected_cantidad < 1) {
        delete filters['stock'];
      }
      if (this.selected_address == '') {
        delete filters['delivery_regions_id'];
      }
      //console.log(this.posts);
      var mJson = this.posts;
      let arrayFilter = this.multiFilter(mJson, filters);
      this.publicaciones = arrayFilter.length;
      this.array_json = arrayFilter;
    },
    getMaterial(material) {
      this.selected_material = material;
      if (this.selected_address != '') {
        let direccion_seleccionada = this.addresses.filter((item) => (item['id'] == this.selected_address));
        this.selected_region_comprador = direccion_seleccionada[0]['region_id'];
      }

      let filters = {
        material_id: this.selected_material,
        state_id: this.selected_state,
        stock: this.selected_cantidad,
        delivery_regions_id: this.selected_region_comprador
      };

      if (this.selected_state == 'T' || this.selected_state == null) {
        delete filters['state_id'];
      }
      if (this.selected_material == 'T' || this.selected_material == null) {
        delete filters['materialjoya_id'];
      }
      if (this.selected_cantidad < 1) {
        delete filters['stock'];
      }
      if (this.selected_address == '') {
        delete filters['delivery_regions_id'];
      }
      //console.log(this.posts);
      var mJson = this.posts;
      let arrayFilter = this.multiFilter(mJson, filters);
      this.publicaciones = arrayFilter.length;
      this.array_json = arrayFilter;
    },
    getRaza(raza) {
      this.selected_raza = raza;
      if (this.selected_address != '') {
        let direccion_seleccionada = this.addresses.filter((item) => (item['id'] == this.selected_address));
        this.selected_region_comprador = direccion_seleccionada[0]['region_id'];
      }

      let filters = {
        raza_id: this.selected_raza,
        state_id: this.selected_state,
        stock: this.selected_cantidad,
        delivery_regions_id: this.selected_region_comprador
      };

      if (this.selected_state == 'T' || this.selected_state == null) {
        delete filters['state_id'];
      }
      if (this.selected_raza == 'T' || this.selected_raza == null) {
        delete filters['raza_id'];
      }
      if (this.selected_cantidad < 1) {
        delete filters['stock'];
      }
      if (this.selected_address == '') {
        delete filters['delivery_regions_id'];
      }
      
      var mJson = this.posts;
      let arrayFilter = this.multiFilter(mJson, filters);
      this.publicaciones = arrayFilter.length;
      this.array_json = arrayFilter;
    },
    getTitulo(titulo) {
      this.selected_titulo = titulo;
      if (this.selected_address != '') {
        let direccion_seleccionada = this.addresses.filter((item) => (item['id'] == this.selected_address));
        this.selected_region_comprador = direccion_seleccionada[0]['region_id'];
      }

      let filters = {
        titulo_id: this.selected_titulo,
        state_id: this.selected_state,
        stock: this.selected_cantidad,
        delivery_regions_id: this.selected_region_comprador
      };

      if (this.selected_state == 'T' || this.selected_state == null) {
        delete filters['state_id'];
      }
      if (this.selected_titulo == 'T' || this.selected_titulo == null) {
        delete filters['titulo_id'];
      }
      if (this.selected_cantidad < 1) {
        delete filters['stock'];
      }
      if (this.selected_address == '') {
        delete filters['delivery_regions_id'];
      }
      
      var mJson = this.posts;
      let arrayFilter = this.multiFilter(mJson, filters);
      this.publicaciones = arrayFilter.length;
      this.array_json = arrayFilter;
    },
    getEvento(evento) {
      this.selected_evento = evento;
      if (this.selected_address != '') {
        let direccion_seleccionada = this.addresses.filter((item) => (item['id'] == this.selected_address));
        this.selected_region_comprador = direccion_seleccionada[0]['region_id'];
      }

      let filters = {
        evento_id: this.selected_evento,
        state_id: this.selected_state,
        stock: this.selected_cantidad,
        delivery_regions_id: this.selected_region_comprador
      };

      if (this.selected_state == 'T' || this.selected_state == null) {
        delete filters['state_id'];
      }
      if (this.selected_evento == 'T' || this.selected_evento == null) {
        delete filters['evento_id'];
      }
      if (this.selected_cantidad < 1) {
        delete filters['stock'];
      }
      if (this.selected_address == '') {
        delete filters['delivery_regions_id'];
      }
      
      var mJson = this.posts;
      let arrayFilter = this.multiFilter(mJson, filters);
      this.publicaciones = arrayFilter.length;
      this.array_json = arrayFilter;
    },
    getArtista(artista) {
      this.selected_artista = artista;
      if (this.selected_address != '') {
        let direccion_seleccionada = this.addresses.filter((item) => (item['id'] == this.selected_address));
        this.selected_region_comprador = direccion_seleccionada[0]['region_id'];
      }

      let filters = {
        artista_id: this.selected_artista,
        state_id: this.selected_state,
        stock: this.selected_cantidad,
        delivery_regions_id: this.selected_region_comprador
      };

      if (this.selected_state == 'T' || this.selected_state == null) {
        delete filters['state_id'];
      }
      if (this.selected_artista == 'T' || this.selected_artista == null) {
        delete filters['artista_id'];
      }
      if (this.selected_cantidad < 1) {
        delete filters['stock'];
      }
      if (this.selected_address == '') {
        delete filters['delivery_regions_id'];
      }
      
      var mJson = this.posts;
      let arrayFilter = this.multiFilter(mJson, filters);
      this.publicaciones = arrayFilter.length;
      this.array_json = arrayFilter;
    },
    getFormato(formato) {
      this.selected_formato = formato;
      if (this.selected_address != '') {
        let direccion_seleccionada = this.addresses.filter((item) => (item['id'] == this.selected_address));
        this.selected_region_comprador = direccion_seleccionada[0]['region_id'];
      }

      let filters = {
        formato_id: this.selected_formato,
        state_id: this.selected_state,
        stock: this.selected_cantidad,
        delivery_regions_id: this.selected_region_comprador
      };

      if (this.selected_state == 'T' || this.selected_state == null) {
        delete filters['state_id'];
      }
      if (this.selected_formato == 'T' || this.selected_formato == null) {
        delete filters['formato_id'];
      }
      if (this.selected_cantidad < 1) {
        delete filters['stock'];
      }
      if (this.selected_address == '') {
        delete filters['delivery_regions_id'];
      }
      
      var mJson = this.posts;
      let arrayFilter = this.multiFilter(mJson, filters);
      this.publicaciones = arrayFilter.length;
      this.array_json = arrayFilter;
    },
    getIdioma(idioma) {
      this.selected_idioma = idioma;
      if (this.selected_address != '') {
        let direccion_seleccionada = this.addresses.filter((item) => (item['id'] == this.selected_address));
        this.selected_region_comprador = direccion_seleccionada[0]['region_id'];
      }

      let filters = {
        idioma_id: this.selected_idioma,
        state_id: this.selected_state,
        stock: this.selected_cantidad,
        delivery_regions_id: this.selected_region_comprador
      };

      if (this.selected_state == 'T' || this.selected_state == null) {
        delete filters['state_id'];
      }
      if (this.selected_idioma == 'T' || this.selected_idioma == null) {
        delete filters['idioma_id'];
      }
      if (this.selected_cantidad < 1) {
        delete filters['stock'];
      }
      if (this.selected_address == '') {
        delete filters['delivery_regions_id'];
      }
      
      var mJson = this.posts;
      let arrayFilter = this.multiFilter(mJson, filters);
      this.publicaciones = arrayFilter.length;
      this.array_json = arrayFilter;
    },
    getLocalidad(localidad) {
      this.selected_localidad = localidad;
      if (this.selected_address != '') {
        let direccion_seleccionada = this.addresses.filter((item) => (item['id'] == this.selected_address));
        this.selected_region_comprador = direccion_seleccionada[0]['region_id'];
      }

      let filters = {
        localidad_id: this.selected_localidad,
        state_id: this.selected_state,
        stock: this.selected_cantidad,
        delivery_regions_id: this.selected_region_comprador
      };

      if (this.selected_state == 'T' || this.selected_state == null) {
        delete filters['state_id'];
      }
      if (this.selected_localidad == 'T' || this.selected_localidad == null) {
        delete filters['localidad_id'];
      }
      if (this.selected_cantidad < 1) {
        delete filters['stock'];
      }
      if (this.selected_address == '') {
        delete filters['delivery_regions_id'];
      }
      
      var mJson = this.posts;
      let arrayFilter = this.multiFilter(mJson, filters);
      this.publicaciones = arrayFilter.length;
      this.array_json = arrayFilter;
    },
    getTallaBebe(tallabebe) {
      this.selected_tallabebe = tallabebe;
      if (this.selected_address != '') {
        let direccion_seleccionada = this.addresses.filter((item) => (item['id'] == this.selected_address));
        this.selected_region_comprador = direccion_seleccionada[0]['region_id'];
      }

      let filters = {
        tallabebe_id: this.selected_tallabebe,
        state_id: this.selected_state,
        stock: this.selected_cantidad,
        delivery_regions_id: this.selected_region_comprador
      };

      if (this.selected_state == 'T' || this.selected_state == null) {
        delete filters['state_id'];
      }
      if (this.selected_tallabebe == 'T' || this.selected_tallabebe == null) {
        delete filters['tallabebe_id'];
      }
      if (this.selected_cantidad < 1) {
        delete filters['stock'];
      }
      if (this.selected_address == '') {
        delete filters['delivery_regions_id'];
      }
      //console.log(this.posts);
      var mJson = this.posts;
      let arrayFilter = this.multiFilter(mJson, filters);
      this.publicaciones = arrayFilter.length;
      this.array_json = arrayFilter;
    },
    getTallaCalzado(tallacalzado) {
      this.selected_tallacalzado = tallacalzado;
      if (this.selected_address != '') {
        let direccion_seleccionada = this.addresses.filter((item) => (item['id'] == this.selected_address));
        this.selected_region_comprador = direccion_seleccionada[0]['region_id'];
      }

      let filters = {
        tallacalzado_id: this.selected_tallacalzado,
        state_id: this.selected_state,
        stock: this.selected_cantidad,
        delivery_regions_id: this.selected_region_comprador
      };

      if (this.selected_state == 'T' || this.selected_state == null) {
        delete filters['state_id'];
      }
      if (this.selected_tallacalzado == 'T' || this.selected_tallacalzado == null) {
        delete filters['tallacalzado_id'];
      }
      if (this.selected_cantidad < 1) {
        delete filters['stock'];
      }
      if (this.selected_address == '') {
        delete filters['delivery_regions_id'];
      }
      //console.log(this.posts);
      var mJson = this.posts;
      let arrayFilter = this.multiFilter(mJson, filters);
      this.publicaciones = arrayFilter.length;
      this.array_json = arrayFilter;
    },
    getTallaRopa(tallaropa) {
      this.selected_tallaropa = tallaropa;
      if (this.selected_address != '') {
        let direccion_seleccionada = this.addresses.filter((item) => (item['id'] == this.selected_address));
        this.selected_region_comprador = direccion_seleccionada[0]['region_id'];
      }

      let filters = {
        tallaropa_id: this.selected_tallaropa,
        state_id: this.selected_state,
        stock: this.selected_cantidad,
        delivery_regions_id: this.selected_region_comprador
      };

      if (this.selected_state == 'T' || this.selected_state == null) {
        delete filters['state_id'];
      }
      if (this.selected_tallaropa == 'T' || this.selected_tallaropa == null) {
        delete filters['tallaropa_id'];
      }
      if (this.selected_cantidad < 1) {
        delete filters['stock'];
      }
      if (this.selected_address == '') {
        delete filters['delivery_regions_id'];
      }
      //console.log(this.posts);
      var mJson = this.posts;
      let arrayFilter = this.multiFilter(mJson, filters);
      this.publicaciones = arrayFilter.length;
      this.array_json = arrayFilter;
    },
    getfilterPosts() {
      if (this.selected_address != '') {
        let direccion_seleccionada = this.addresses.filter((item) => (item['id'] == this.selected_address));
        this.selected_region_comprador = direccion_seleccionada[0]['region_id'];
      }

      let filters = {
        transductor_id: this.selected_transductor,
        arobicicleta_id: this.selected_aro,
        genero_id: this.selected_genero,
        sexo_id: this.selected_sexo,
        materialjoya_id: this.selected_materialjoya,
        material_id: this.selected_material,
        raza_id: this.selected_raza,
        titulo_id: this.selected_titulo,
        evento_id: this.selected_evento,
        artista_id: this.selected_artista,
        formato_id: this.selected_formato,
        idioma_id: this.selected_idioma,
        localidad_id: this.selected_localidad,
        tallabebe_id: this.selected_tallabebe,
        tallacalzado_id: this.selected_tallacalzado,
        tallaropa_id: this.selected_tallaropa,
        state_id: this.selected_state,
        stock: this.selected_cantidad,
        delivery_regions_id: this.selected_region_comprador
      };

      //console.log('genero:'+this.selected_genero);

      if (this.selected_state == 'T' || this.selected_state == null) {
        delete filters['state_id'];
      }
      if (this.selected_transductor == 'T' || this.selected_transductor == null) {
        delete filters['transductor_id'];
      }
      if (this.selected_aro == 'T' || this.selected_aro == null) {
        delete filters['arobicicleta_id'];
      }  
      if (this.selected_genero == 'T' || this.selected_genero == null) {
        delete filters['genero_id'];
      }  
      if (this.selected_sexo == 'T' || this.selected_sexo == null) {
        delete filters['sexo_id'];
      }  
      if (this.selected_materialjoya == 'T' || this.selected_materialjoya == null) {
        delete filters['materialjoya_id'];
      }  
      if (this.selected_material == 'T' || this.selected_material == null) {
        delete filters['material_id'];
      } 
      if (this.selected_raza == 'T' || this.selected_raza == null) {
        delete filters['raza_id'];
      } 
      if (this.selected_titulo == 'T' || this.selected_titulo == null) {
        delete filters['titulo_id'];
      } 
      if (this.selected_evento == 'T' || this.selected_evento == null) {
        delete filters['evento_id'];
      }       
      if (this.selected_artista == 'T' || this.selected_artista == null) {
        delete filters['artista_id'];
      } 
      if (this.selected_formato == 'T' || this.selected_formato == null) {
        delete filters['formato_id'];
      } 
      if (this.selected_idioma == 'T' || this.selected_idioma == null) {
        delete filters['idioma_id'];
      } 
      if (this.selected_localidad == 'T' || this.selected_localidad == null) {
        delete filters['localidad_id'];
      }   
      if (this.selected_tallabebe == 'T' || this.selected_tallabebe == null) {
        delete filters['tallabebe_id'];
      }
      if (this.selected_tallacalzado == 'T' || this.selected_tallacalzado == null) {
        delete filters['tallacalzado_id'];
      }
      if (this.selected_tallaropa == 'T' || this.selected_tallaropa == null) {
        delete filters['tallaropa_id'];
      }
      if (this.selected_cantidad < 1) {
        delete filters['stock'];
      }
      if (this.selected_address == '') {
        delete filters['delivery_regions_id'];
      }

      var mJson = this.posts;
      let arrayFilter = this.multiFilter(mJson, filters);
      this.publicaciones = arrayFilter.length;
      this.array_json = arrayFilter;
    },
    multiFilter(array, filters) {
      //console.log(array);
      let filterKeys = Object.keys(filters);
      if (filterKeys.length > 0) {
        const result = filterKeys.filter((key) => {
          //alert(array);
          switch (key) {
            case "stock":
              //selecciona solo aquellos que tengan stock para la cantidad ingresada
              array = array.filter((item) => (item[key] >= this.selected_cantidad));
            break;

            case "state_id":
              //selecciona solo aquellos que cumplan con el estado seleccionado
              array = array.filter((item) => filters[key].toString().indexOf(item[key]) !== -1)
            break;

            case "transductor_id":
              //selecciona solo aquellos que cumplan con el atributo transductor
              array = array.filter((item) => filters[key].toString().indexOf(item[key]) !== -1)
            break;

            case "arobicicleta_id":
              //selecciona solo aquellos que cumplan con el atributo aro de bicicleta
              array = array.filter((item) => filters[key].toString().indexOf(item[key]) !== -1)
            break;            

            case "genero_id":
              //selecciona solo aquellos que cumplan con el atributo genero
              array = array.filter((item) => filters[key].toString().indexOf(item[key]) !== -1)
            break;

            case "sexo_id":
              //selecciona solo aquellos que cumplan con el atributo sexo
              array = array.filter((item) => filters[key].toString().indexOf(item[key]) !== -1)
            break;

            case "materialjoya_id":
              //selecciona solo aquellos que cumplan con el atributo materialjoya
              array = array.filter((item) => filters[key].toString().indexOf(item[key]) !== -1)
            break;

            case "raza_id":
              //selecciona solo aquellos que cumplan con el atributo raza
              array = array.filter((item) => filters[key].toString().indexOf(item[key]) !== -1)
            break;

            case "titulo_id":
              //selecciona solo aquellos que cumplan con el atributo titulo
              array = array.filter((item) => filters[key].toString().indexOf(item[key]) !== -1)
            break;

            case "evento_id":
              //selecciona solo aquellos que cumplan con el atributo evento
              array = array.filter((item) => filters[key].toString().indexOf(item[key]) !== -1)
            break;

            case "artista_id":
              //selecciona solo aquellos que cumplan con el atributo artista
              array = array.filter((item) => filters[key].toString().indexOf(item[key]) !== -1)
            break;

            case "formato_id":
              //selecciona solo aquellos que cumplan con el atributo formato
              array = array.filter((item) => filters[key].toString().indexOf(item[key]) !== -1)
            break;

            case "idioma_id":
              //selecciona solo aquellos que cumplan con el atributo idioma
              array = array.filter((item) => filters[key].toString().indexOf(item[key]) !== -1)
            break;

            case "localidad_id":
              //selecciona solo aquellos que cumplan con el atributo localidad
              array = array.filter((item) => filters[key].toString().indexOf(item[key]) !== -1)
            break;

            case "tallabebe_id":
              //selecciona solo aquellos que cumplan con el atributo talla de bebé
              array = array.filter((item) => filters[key].toString().indexOf(item[key]) !== -1)
            break;

            case "tallacalzado_id":
              //selecciona solo aquellos que cumplan con el atributo talla de calzado
              array = array.filter((item) => filters[key].toString().indexOf(item[key]) !== -1)
            break;

            case "tallaropa_id":
              //selecciona solo aquellos que cumplan con el atributo talla de ropa
              array = array.filter((item) => filters[key].toString().indexOf(item[key]) !== -1)
            break;

            case "delivery_regions_id":
              //selecciona solo aquellos que cumplan con el atributo transductor
              array = array.filter((item) => (item[key].toString().split(',').includes(this.selected_region_comprador.toString()) || item[key] == 'Todas'));
            break;
          }
        });
      }
      return array;
    },
    setNotificar(){
      
      if (this.isChecked){
        this.notificar = 1;
        this.elementoClaseNotificacion =  'col-12 text-justify alert alert-success ml-2 mar-2';
      }
      else{
        this.notificar = 0;
        this.elementoClaseNotificacion =  'col-12 text-justify alert alert-danger ml-2 mar-2';
      }
    },
    onComplete: function () {
      if (!validar(document.formulario)) {
        this.$swal.fire({
          text: 'Por favor, revisa y completa los datos solicitados.',
          title: 'Algunos de los datos ingresados no son correctos',
          icon: 'error',
          confirmButtonColor: '#3490dc',
          confirmButtonText: 'Aceptar',
        });
      }
      else {
        if (this.publicaciones == 0 || this.selected_pujatime == 1) {
          if (!this.post_seleccionado.rating_user.delivery_regions_id.split(',').includes(this.selected_region_comprador.toString()) && this.post_seleccionado.rating_user.delivery_regions_id != 'Todas' && this.publicaciones == 0) {
            this.$swal.fire({
              html: 'El vendedor del producto que seleccionaste, no entrega en la región de tu dirección <i class="far fa-sad-cry text-danger fa-2x"></i>',
              title: 'No hay coincidencia con zonas de entrega',
              icon: 'error',
              confirmButtonColor: '#3490dc',
              confirmButtonText: 'Aceptar'
            });
          }
          else {//compra directa entrega a regiones ok
            /*this.$swal.fire({
              title: 'Esta acción generará una petición de compra directa',
              html: "Si <b>no hay artículos que coincidan con los filtros ingresados</b> o el tiempo de puja es de <b>1 minuto</b>, se aplicará el proceso de compra directa.",
              icon: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Comprar',
              cancelButtonText: 'Cancelar'
            }).then((result) => {
              if (result.isConfirmed) {
            */  
            if (this.notificar == 0){
              this.$swal.fire({
                text: 'Para comenzar el proceso de compra directa, debes aceptar los términos y condiciones.',
                title: 'Tienes que aceptar los términos y condiciones',
                icon: 'error',
                confirmButtonColor: '#3490dc',
                confirmButtonText: 'Aceptar',
              });
            }
            else{

                this.savePuja();
                setTimeout(() => {
                  if (this.id_puja != '') {
                    if (this.publicaciones == 1 || this.selected_pujatime == 1) {
                      this.publicaciones = 2;
                      this.selected_pujatime = 2;
                      this.$router.push({ path: '/compras' });
                    }
                    else {
                      this.$router.replace({ name: 'puja', params: { id: this.id_puja } });
                    }
                    this.$router.go();
                  }
                  else {
                    this.$router.replace({ name: '/' });
                    this.$router.go();
                  }
                }, 2000);
              }
            }  
            //})
          //}
        } else {
          if (!this.post_seleccionado.rating_user.delivery_regions_id.split(',').includes(this.selected_region_comprador.toString()) && this.post_seleccionado.rating_user.delivery_regions_id != 'Todas') {
            if (this.publicaciones == 0) {
              this.$swal.fire({
                html: 'El vendedor del producto que seleccionaste, no entrega en la región de tu dirección <i class="far fa-sad-cry text-danger fa-2x"></i>',
                title: 'No hay coincidencia con zonas de entrega',
                icon: 'error',
                confirmButtonColor: '#3490dc',
                confirmButtonText: 'Aceptar'
              });
            }
            else {
              this.pujar_sin_seleccion = 1;
              this.$swal.fire({
                title: 'El vendedor del producto que estás consultando, no entrega en la zona de la dirección seleccionada',
                html: "Podemos levantar una oferta utilizando los productos que hemos encontrado que son similares a este, incluyendo los filtros que has ingresado",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Aceptar',
                cancelButtonText: 'Cancelar'
              }).then((result) => {
                if (result.isConfirmed) {
                  this.savePuja();
                  setTimeout(() => {
                    if (this.id_puja != '') {
                      if (this.publicaciones == 1 || this.selected_pujatime == 1) {
                        this.publicaciones = 2;
                        this.selected_pujatime = 2;
                        this.$router.push({ path: '/compras' });
                      }
                      else {
                        this.$router.replace({ name: 'puja', params: { id: this.id_puja } });
                      }
                      this.$router.go();
                    }
                    else {
                      this.$router.replace({ name: '/compras' });
                      this.$router.go();
                    }
                  }, 2000);
                }
              })
            }
          }
          else{
            this.savePuja();
            setTimeout(() => {
              if (this.id_puja != ''){
                this.$router.push({ path: '/puja/'+this.id_puja } );
                this.$router.replace({ name: 'puja', params: { id: this.id_puja } });
                this.$router.go();
              }
            }, 3000);
          }
        }        
      }
    },
    onChange() {
      this.selected_pujatime = '';
      this.validar();
      $('.selectpicker').selectpicker('refresh');
      if (this.publicaciones == 0 && this.$route.path != '/inicio'  && this.$route.path != '/' && this.$route.path != '/list' && this.$route.path != '/inicio/list' && this.$route.path != '/login') {
        this.$swal.fire({
          text: 'No se puede levantar una oferta con los filtros utilizados, si quieres continuar, se generará una compra directa de éste artículo.',
          title: 'No hay coincidencias con los atributos ingresados',
          icon: 'warning',
          confirmButtonColor: '#3490dc',
          confirmButtonText: 'Aceptar'
        });
      }

      if (this.publicaciones < 1) {
        this.selected_pujatime = 1;
        this.validar();
      }
    },
    validar() {
      if (this.selected_pujatime == 1 && !this.isChecked){
        this.elementoClaseNotificacion = 'col-12 text-justify alert alert-danger ml-2 mar-2';
      }
      else if (this.selected_pujatime != 1){
        this.elementoClaseNotificacion = 'col-12 text-justify alert alert-danger ml-2 mar-2 d-none';
        this.isChecked = false;
      }
      validar(document.formulario);
      $('.selectpicker').selectpicker('refresh');
    },
    savePuja() {
      //Si el tiempo de puja es de 1 minuto se hace compra directa, por lo que se debe enviar los datos del post seleccionado
      if (this.selected_pujatime <= 1) {
        this.array_json = null;
      }
      axios.post('/api/puja/store', { //estas variables son las que enviaremos para que crear la tarea
        'array': JSON.stringify(this.array_json),
        'category_path': this.post_seleccionado.category_path,
        'title': this.post_seleccionado.title,
        'address': this.selected_address,
        'tiempo': this.selected_pujatime,
        'post_seleccionado': JSON.stringify(this.post_seleccionado),
        'cantidad': this.selected_cantidad,
        'pujar_sin_seleccion': this.pujar_sin_seleccion
      }).then((response) => {
        //console.log(response.data);
        if (response.data.msj == 'puja_creada') {
          this.id_puja = response.data.data;
          if (this.selected_pujatime > 1) {
            this.$swal.fire({
              text: 'La oferta se mantendrá activa hasta que se cumpla la fecha final, de acuerdo a los atributos ingresados. Una vez iniciada no se puede eliminar',
              title: 'Se ha iniciado la oferta correctamente',
              icon: 'success',
              button: 'Aceptar'
            });
          }
          else {
            this.$swal.fire({
              html: 'Esta compra se mantendrá con estado <b>"En proceso"</b>, mientras el vendedor no confirme la venta',
              title: 'Se ha iniciado el proceso de compra directa',
              icon: 'success',
              confirmButtonColor: '#3490dc',
              confirmButtonText: 'Aceptar'
            });
          }

        }
        else if (response.data.msj == 'compra_sin_stock') {
          this.$swal.fire({
            text: 'Al momento de hacer la compra, el producto ya fue vendido, por lo que ya no tiene stock disponible',
            title: 'No se ha podido realizar la compra',
            icon: 'error',
            confirmButtonColor: '#3490dc',
            confirmButtonText: 'Aceptar'
          });
        }
      })
        .catch((response) => {
          this.id_puja = '';
          this.$swal.fire({
            text: 'Por favor, trata de realizar el proceso nuevamente',
            title: 'No se ha podido iniciar la oferta',
            icon: 'error',
            confirmButtonColor: '#3490dc',
            confirmButtonText: 'Aceptar'
          });
        });

    },
    irTerminos(){
      this.$router.push('/terminos');
      this.$router.go();
    }
  },
  data: function () {
    return {
      filtrosUrl: {
        transductor: '',
        state: '',
      },
      postSelected: "",
      posts: [],
      array_json: [],
      array_json_original: [],
      states: [],
      addresses: [],
      total: 0,
      currentPage: 1,
      publicaciones: 0,
      shownPets: null,
      selected_state: this.post_seleccionado.state_id,
      selected_transductor: this.post_seleccionado.transductor_id,
      selected_pujatime: '',
      selected_address: '',
      id_puja: '',
      selected_cantidad: '',
      selected_region_comprador: '',
      pujar_sin_seleccion: 0,
      elementoClaseNotificacion: 'col-12 text-justify alert alert-danger ml-2 mar-2',
      isChecked: false,
      notificar: 0,
      url_terminos: window.location.origin + '/terminos',
      dominio: window.location.origin + '/manual'
    };
  },
};
</script>